function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRoomNoSmokingFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M22.948 21h-2.84l6.922 9h-2.523L2.97 2h2.523l8.461 11h8.995v2h-7.456l3.076 4h4.38v2zM4.052 15v4h9.993l1.539 2H3.052a1 1 0 01-1-1v-6a1 1 0 011-1H9.43l1.539 2H4.052zM27.949 21h2v-8h-2v8zM26.949 21h-2v-8h2v8zM22.589 6.004c2.955 0 5.359 2.233 5.359 4.978h2c0-3.848-3.301-6.978-7.359-6.978-1.209 0-2.193-.898-2.193-2.001h-2c0 2.206 1.88 4 4.193 4z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.948 10.98c0-1.102-.984-2-2.193-2-4.058 0-7.359-3.13-7.359-6.978h2c0 2.745 2.404 4.978 5.359 4.978 2.312 0 4.193 1.795 4.193 4h-2z",
    fill: props.color
  }));
}

export default SvgIconRoomNoSmokingFilled;